import React, { useEffect, useState } from 'react';
import { Button } from './common/Button';
import { Mail } from 'lucide-react';
export function WaitlistSection() {
  const [gifUrl, setGifUrl] = useState('');
  useEffect(() => {
    // Append a timestamp to force the browser to load the GIF fresh,
    // ensuring it syncs perfectly with the CSS animation start time.
    setGifUrl(`https://gifgifs.com/animations/animals/elephants/Elephant_butt.gif?t=${Date.now()}`);
  }, []);
  return <section className="py-32 bg-[#1A1A1A] relative overflow-hidden" data-id="element-921" data-mp="9qo9lqoa8k2e">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-922" data-mp="4zg0ywus12qa">
        <div className="absolute -top-24 -left-24 w-64 h-64 bg-[#FFFC00] rounded-full opacity-10 blur-3xl" data-id="element-923" data-mp="ymg6ccms41m"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full opacity-5 blur-3xl" data-id="element-924" data-mp="xgimg88lq8mn"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-925" data-mp="soqvhwlja0vz">
        <h2 className="text-5xl sm:text-7xl font-black mb-8 text-white uppercase tracking-tight" data-id="element-926" data-mp="1zoy6i1pkipw5">
          Ready to get <span className="text-[#FFFC00]" data-id="element-927" data-mp="24lomkp1dhlhk">rewarded?</span>
        </h2>
        <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto font-medium" data-id="element-928" data-mp="1pyvea3q9tfyv">
          Join hundreds of shoppers earning free perks at their favorite local
          spots.
        </p>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-6 mb-6" data-id="element-929" data-mp="1gwvwvabcg9ve">
          <Button variant="primary" size="lg" href="https://kraya.live/" className="text-xl py-5 px-12 shadow-[4px_4px_0px_0px_rgba(255,255,255,0.2)] hover:shadow-none hover:translate-y-1 transition-all" data-id="element-930" data-mp="1lw8jpv27tgxz">
            Download the app
          </Button>
        </div>

        <p className="text-xl text-gray-300 font-medium" data-id="element-931" data-mp="31ebn6zvo13mw">Got more questions?</p>

        {/* Playful Contact Section with Kicking Elephant */}
        <div className="mt-6 flex justify-center items-center relative" data-id="element-932" data-mp="36a92d2v703y3">
          <style data-id="element-933" data-mp="34wr9g1yjzrk4">{`
            @keyframes kick-slide {
              0%, 85% { transform: translateX(0) rotate(2deg); }
              90% { transform: translateX(15px) rotate(4deg); }
              95% { transform: translateX(0) rotate(2deg); }
              100% { transform: translateX(0) rotate(2deg); }
            }
            .animate-kick-slide {
              animation: kick-slide 2s infinite;
            }
            .elephant-matte-fix {
              /* Use drop-shadow and contrast to blend the white edges into the dark background */
              filter: drop-shadow(0 0 1px #1A1A1A) drop-shadow(0 0 2px #1A1A1A) contrast(1.1);
              mix-blend-mode: multiply;
            }
          `}</style>

          <div className="relative z-10 -mr-4 mt-8 pointer-events-none" data-id="element-934" data-mp="39s6jsjxcr5bs">
            {gifUrl && <img src={gifUrl} alt="Kicking Elephant" className="w-24 h-auto elephant-matte-fix" data-id="element-935" data-mp="a8vw7hb95hrb" />}
          </div>

          <div className="animate-kick-slide" data-id="element-936" data-mp="1o4niw34zn25j">
            <a href="mailto:hello@kraya.app" className="group relative inline-flex items-center gap-3 bg-[#FF90E8] border-4 border-[#1A1A1A] rounded-2xl py-4 px-8 shadow-[6px_6px_0px_0px_rgba(255,252,0,1)] hover:shadow-[2px_2px_0px_0px_rgba(255,252,0,1)] transition-shadow duration-200" data-id="element-937" data-mp="1t1dv2fdo9dlo">
              <Mail className="w-8 h-8 text-[#1A1A1A] group-hover:animate-wiggle" data-id="element-938" data-mp="270vlez6m8yx5" />
              <div className="text-left" data-id="element-939" data-mp="2bzq5e4gbktiu">
                <p className="text-[#1A1A1A] font-bold text-xl leading-none" data-id="element-940" data-mp="2byne3vf34p2e">
                  Slide into our inbox
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>;
}